

import templateUserProfileFormModal from '@/app-template/lib/components/UserProfileFormModal.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UserProfileFormModal',
  components: { templateUserProfileFormModal },
});
